import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { AdPetType } from '@/graphql/generated/schemas'

const useWelcomeDealEventTracker = () => {
  const tracker = useTracker()
  const trackClick100WondealSignupEvent = (petType: AdPetType) => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.Click100WondealSignup, {
      petType100WonDeal: petType,
    })
  }

  return {
    trackClick100WondealSignupEvent,
  }
}

export { useWelcomeDealEventTracker }
